import store, { data, form } from '../../store'
import { setContact } from '@app/memberships/state/partials/helpers/watches/details/watchMembershipTypeDetails'

export default function populateFormFromData(){
    const booking = data.event_booking.details.value
    const event   = data.event.details.value

    const dataContainer = booking.attendees[0]

    const ticket = event.tickets.find((ticket) => ticket.id === dataContainer.ticket.id)
        
    ticket.cheapest_price = dataContainer.price    
    ticket.cheapest_price.price = dataContainer.cost

    form.fields.value.forename = booking.forename
    form.fields.value.middle_name = booking.middle_name
    form.fields.value.surname = booking.surname
    
    setContact(form, booking.contact)

    form.fields.value.ticket = {
        quantity : booking.attendees.length,
        people   : booking.attendees.map(
            (attendee) => ({
                forename    : attendee.forename,
                middle_name : attendee.middle_name,
                surname     : attendee.surname,
                email       : attendee.email,
                fields      : attendee.fields.reduce(
                    (fields, field) => ({
                        ...fields,
                        [field.field_id]: field.answer
                    }),
                    {}
                )
            }) 
        ),
        ticket: ticket,
    }

    form.fields.value.options = event.options.filter(
        (option) => dataContainer.booking_options.findIndex(
            (bookedOption) => bookedOption.option_id === option.id
        ) !== -1
    ),

    form.fields.value.workshops = dataContainer.booking_timeslots.reduce(
        (workshops, timeslot) => {
            workshops[timeslot.timeslot_id] = event.workshops.find((workshop) => timeslot.workshop_id === workshop.id)

            return workshops
        },
        {}
    )

    form.steps.current_stage.value = 'confirmation'

    store.view_only.value = true
}